export default (value, decimal) => {
  if (!value && value !== 0) return '-'

  const locale =
    import.meta.env.VITE_COUNTRY === 'tr' ? 'tr-TR' : import.meta.env.VITE_COUNTRY === 'tr' ? 'en-US' : 'ro-RO'
  const options = {
    minimumFractionDigits: decimal ? 2 : 0,
    maximumFractionDigits: decimal ? 2 : 0
  }
  value = parseFloat(value).toLocaleString(locale, options)

  if (import.meta.env.VITE_COUNTRY === 'tr') {
    return '%' + value
  }
  return value + '%'
}
